import clsx from 'clsx';
import React from 'react';

import styles from './deprecationToggle.module.scss';

type DeprecationToggleProps = {
  entityNamePlural: string;
  showDeprecated: boolean;
  onChange: ( next: boolean ) => void;
};

export function DeprecationToggle( {
  entityNamePlural,
  showDeprecated,
  onChange
}: DeprecationToggleProps ) {
  return (
    <span className={ styles.wrapper }>
      <span>Deprecated { entityNamePlural }:</span>
      <div
        role="group"
        aria-label={ `Show/hide deprecated ${ entityNamePlural }` }
        className={ styles.toggleGroup }
        title={ `Toggle visibility of deprecated ${ entityNamePlural }` }
      >
        <button
          type="button"
          aria-pressed={ !showDeprecated }
          onClick={ () => onChange( false ) }
          className={ clsx( styles.button, { [ styles.active ]: !showDeprecated } ) }
        >
          Hide
        </button>
        <button
          type="button"
          aria-pressed={ showDeprecated }
          onClick={ () => onChange( true ) }
          className={ clsx( styles.button, { [ styles.active ]: showDeprecated } ) }
        >
          Show
        </button>
      </div>
    </span>
  );
}
